import { render } from "./VerificationUnsuccessful.vue?vue&type=template&id=82c03296&scoped=true"
import script from "./VerificationUnsuccessful.vue?vue&type=script&lang=js"
export * from "./VerificationUnsuccessful.vue?vue&type=script&lang=js"

import "./VerificationUnsuccessful.vue?vue&type=style&index=0&id=82c03296&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82c03296"]])

export default __exports__